// @flow
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { isBrowser } from 'react-device-detect';
import Circles from 'components/common/Loaders/Circles';
import cx from 'classnames';

import './ForgotForm.scss';
import Button from '../../common/Button';

type Props = {
  onChangeEmail(e: Event): void,
  onChangePassword(e: Event): void,
  onSendVerification(): Promise<*>,
  onReTryVerification(): Promise<*>,
  onEnterKeyPress(e: KeyboardEvent): void,
  onSocialLogin(provider: string): Promise<*>,
  email: string,
  password: string,
  sentEmail: boolean,
  sending: boolean,
  isUser: boolean,
  typeName: string,
  isEmailVerified: boolean,
  isEmailCapitalized: boolean,
};

const ForgotForm = ({
  onChangeEmail,
  onSendVerification,
  onReTryVerification,
  onEnterKeyPress,
  email,
  password,
  sentEmail,
  sending,
  isUser,
  typeName,
  isEmailVerified,
  isEmailCapitalized,
}: Props) => {
  useEffect(() => {
    if (this.email) this.email.focus();
    if (this.password) this.password.focus();
  });

  return (
    <div className="ForgotForm">
      <Link to="/" className="brand">
        <img src="https://images.cacheby.com/logo.svg" alt="CacheBy" />
      </Link>
      <div className={cx('input-with-button', { sending })}>
        <input
          className="email"
          placeholder="이메일"
          type="email"
          value={email}
          onChange={onChangeEmail}
          disabled={sending}
          onKeyPress={onEnterKeyPress}
        />
        {isEmailCapitalized && (
          <div className="email-validation-warning">대문자를 사용하실 수 없습니다.</div>
        )}
        {/* {!isEmailCapitalized && !isEmailVerified && (
          <div className="email-validation-warning">유효한 이메일 주소가 아닙니다.</div>
        )} */}
        <Button fullWidth large theme="default" color="blue" onClick={onSendVerification} desktop={isBrowser}>
          {sending ? <Circles size="small" color="white" text='보내는 중...' /> : '이메일로 비밀번호 찾기'}
        </Button>
      </div>
    </div>
  );
};

export default ForgotForm;



// WEBPACK FOOTER //
// ./src/components/auth/ForgotForm/ForgotForm.js